<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Контакты</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="nas-legko-nayti"
            class="typography__headline2"
          >
            Нас легко найти
          </FaqArticlesBlockHeading>

          <div class="block__social typography__body1">
            <div class="block-social__item">
              Почта

              <BaseLink
                class="ui-link-big ui-link-secondary social-item__link"
                to="mailto:sayhi@muynut.app"
              >
                sayhi@muynut.app
              </BaseLink>
            </div>

            <div class="block-social__item">
              Социальные сети

              <ul class="social-item__list">
                <li>
                  <BaseLink>
                    <BaseIcon2
                      id="icon-x-colored"
                      height="24"
                      sprite="socials"
                      width="24"
                    />
                  </BaseLink>
                </li>

                <li>
                  <BaseLink>
                    <BaseIcon2
                      id="icon-instagram-colored"
                      height="24"
                      sprite="socials"
                      width="24"
                    />
                  </BaseLink>
                </li>

                <li>
                  <BaseLink>
                    <BaseIcon2
                      id="icon-facebook-colored"
                      height="24"
                      sprite="socials"
                      width="24"
                    />
                  </BaseLink>
                </li>
              </ul>
            </div>

            <div class="block-social__item">
              Telegram

              <BaseLink
                class="ui-link-big ui-link-secondary social-item__link"
                to="https://t.me/donutapp"
              >
                t.me/donutapp
              </BaseLink>
            </div>
          </div>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Основная информация",
    url: "/faq/categories/osnovnaya-informatsiya",
  },
  {
    name: "Контакты",
  },
];

const menu = [
  {
    name: "Нас легко найти",
    url: "nas-legko-nayti",
  },
];

const relatedArticles = [
  {
    name: "Что такое MyDonut",
    slug: "сhto-takoye-MyDonut",
  },
  {
    name: "Тарифы",
    slug: "tarify",
  },
  {
    name: "Регистрация и&nbsp;начало работы",
    slug: "registratsiya-i-nachalo-raboty",
  },
];

useSeoMeta({
  title: "Контакты",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.block__social {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
}

@media (--md) {
  .block__social {
    flex-direction: row;
    column-gap: 24px;
  }
}

.block-social__item {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
  color: var(--grey-2);
}

.social-item__link {
  justify-content: flex-start;
}

.block-social__item .social-item__list {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  list-style-type: none;
}
</style>
